<div>
	<div class="alert-wrapper" [ngClass]="{'alert-success': alertType === AlertTypeEnum.Success, 'alert-error': alertType === AlertTypeEnum.Error, 'alert-info': alertType === AlertTypeEnum.Info, 'alert-warning': alertType === AlertTypeEnum.Warning, 'alert-wrapper-wide': wide, 'alert-wrapper-skinny': !wide, 'alert-wrapper-margin': margin}">
		<span class="alert-icon">
			<i class="fas" [ngClass]="{'fa-exclamation-circle': alertType === AlertTypeEnum.Error, 'fa-check-circle': alertType === AlertTypeEnum.Success, 'fa-info-circle': alertType === AlertTypeEnum.Info,'fa-exclamation-triangle': alertType === AlertTypeEnum.Warning}"></i>
		</span>
		<span class="alert-msg" [ngClass]="{'alert-msg-wide': wide, 'alert-msg-skinny': !wide}">
			<ng-content></ng-content>
		</span>
	</div>
</div>
